import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Path } from "react-native-svg";

const Gradient = (props) => (
	<Svg
		{...props}
		width={750}
		height={33}
		viewBox="0 0 750 33"
		xmlns="http://www.w3.org/2000/svg">
		<Defs>
			<LinearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a">
				<Stop offset="0%" />
				<Stop stopOpacity={0} offset="100%" />
			</LinearGradient>
		</Defs>
		<Path
			fill="url(#a)"
			d="M0 0h750v33H0z"
			fillRule="evenodd"
			fillOpacity={0.2}
		/>
	</Svg>
);

export default Gradient;
